import { ApolloError } from 'apollo-client';

export default function getGraphQLError(e){

    if(e instanceof ApolloError && (e.graphQLErrors || []).length > 0){
        return e.graphQLErrors[0].code;
    }
    else if(e && e.body && (e.body.errors || []).length > 0){
        return e.body.errors[0].code;
    }

    return null
}
